import { useState } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ReactComponent as ChevronRight } from "../../Assets/Icons/chevron-right.svg";
import MobileCountryDropdown from "./Dropdowns/MobileCountry";
import { ReactComponent as BackIcon } from "../../Assets/Icons/back.svg";

const Sidebar = ({
  toggleSideBar,
  navList,
  countries = [],
  innerDropdownToggler,
}) => {
  const { pathname } = useLocation();

  const [dropdownState, setDropdownState] = useState({
    isOpen: false,
    content: [],
  });

  const openDropdown = (e, content) => {
    e.stopPropagation();
    setDropdownState({
      isOpen: true,
      content,
    });
    if (innerDropdownToggler.current) {
      innerDropdownToggler.current.checked = true;
    }
  };

  const closeDropdown = (e) => {
    e.stopPropagation();
    setDropdownState({
      isOpen: false,
      content: null,
    });
    if (innerDropdownToggler.current) {
      innerDropdownToggler.current.checked = false;
    }
  };

  const handleSideBarClick = () => {
    if (innerDropdownToggler.current) {
      innerDropdownToggler.current.checked = false;
    }
    toggleSideBar();
  };

  return (
    <ul
      onClick={handleSideBarClick}
      className="relative bg-white h-full w-full font-poppins font-semibold leading-wider text-xs  text-boudoir leading-snug  "
    >
    
      <input ref={innerDropdownToggler} className="toggler" type="checkbox" />
      <li className="absolute top-0 h-full bg-white w-full toggled toggled2">
        <button
          onClick={closeDropdown}
          className="outline-none font-bold layout__wrapper py-4 border-t border-moon w-full text-left"
        >
          <BackIcon />
        </button>
        {dropdownState?.content}
      </li>

      {navList?.map((nav) => {
                if (nav?.check && !nav.check()) {
                  return null;
                }
        if (nav?.isDropdown) {
          let content =
            nav?.title === "Countries" ? (
              <MobileCountryDropdown
                pathname={pathname}
                countries={countries}
              />
            ) : (
              nav?.content
            );

          return (
            <li
              onClick={(e) => openDropdown(e, content)}
              className={clsx({
                "border-t border-moon last:border-b ": true,
                "bg-drWhite text-chestNut": pathname.includes(nav?.path),
              })}
            >
              <span className="flex item-center w-full  px-8 md:px-12 py-4 ">
                <span className="flex items-center">{nav?.title}</span>

                <ChevronRight />
              </span>
            </li>
          );
        }
        return (
          <li
            className={clsx({
              "border-t border-moon last:border-b ": true,
              "bg-drWhite text-chestNut": pathname.includes(nav?.path),
            })}
          >
            <Link to={nav?.path}>
              <span className=" w-full inline-block md:px-12 px-8 py-4 ">
                {nav?.title}
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default Sidebar;
